export const styles = theme => ({
  loadingMessage: {
    animation: "loading-animation normal 1s infinite"
  }
});
